import _ from 'lodash';

export const CALENDAR_TYPES = {
  ACADEMIC_PLANNER: 'AcademicPlanner',
  SESSIONS: 'Sessions',
};

export const CALENDAR_TYPES_DEFAULT = CALENDAR_TYPES.ACADEMIC_PLANNER;

export const RESOURCE_TYPES = {
  FACULTY: 'faculty',
  FACILITY: 'facility',
};

export const RESOURCE_TYPES_DEFAULT = RESOURCE_TYPES.FACULTY;
export const RESOURCE_TYPES_OPTIONS = [
  {
    label: 'Faculty',
    value: RESOURCE_TYPES.FACULTY,
  },
  {
    label: 'Facility',
    value: RESOURCE_TYPES.FACILITY,
  },
];
export const EVENT_TYPES = {
  REFERENCE: 'planned',
  ACTIVITY: 'activity',
  SESSION: 'actual',
  ALL: 'all',
};
export const EVENT_TYPES_DEFAULT = EVENT_TYPES.ALL;

export const EVENT_TYPE_OPTIONS = [
  {
    label: 'Planned',
    value: EVENT_TYPES.REFERENCE,
  },
  // {
  //   label: 'Exam',
  //   value: EVENT_TYPES.ACTIVITY,
  // },
  {
    label: 'Actual',
    value: EVENT_TYPES.SESSION,
  },
  {
    label: 'All',
    value: EVENT_TYPES.ALL,
  },
];

export const RECURRENT_DAYS = [
  {
    value: 'Sunday',
    label: 'SUN',
  },
  {
    value: 'Monday',
    label: 'MON',
  },
  {
    value: 'Tuesday',
    label: 'TUE',
  },
  {
    value: 'Wednesday',
    label: 'WED',
  },
  {
    value: 'Thursday',
    label: 'THU',
  },
  {
    value: 'Friday',
    label: 'FRI',
  },
  {
    value: 'Saturday',
    label: 'SAT',
  },
];

export const SUBJECT_UNASSIGNED = 'Unassigned';

export const getResources = function (
  resourceType = RESOURCE_TYPES_DEFAULT,
  { faculties, facilities }
) {
  let resources = [];
  let resourceColumns = [];
  if (resourceType === RESOURCE_TYPES.FACULTY) {
    // ?.map(f => ({ ...f, id: f.facultyId }));
    resources = faculties;
    resourceColumns = [{ field: 'facultyName', headerContent: 'Faculty' }];
  } else if (resourceType === RESOURCE_TYPES.FACILITY) {
    // ?.map(f => ({ ...f }));
    resources = facilities;
    resourceColumns = [
      { field: 'facilityName', headerContent: 'Facility' },
      { field: 'facilityCapacity', headerContent: 'Capacity' },
      { field: 'facilityType', headerContent: 'Type' },
    ];
  }
  return { resources, resourceColumns };
};

export const eventsResourceMapping = function (
  events = [],
  resourceType = RESOURCE_TYPES_DEFAULT
) {
  // map resources by event type and resourceType

  // based on resourceType change resourceId
  return events.map((e) => {
    switch (e.eventType) {
      case EVENT_TYPES.REFERENCE:
        return resourceType === RESOURCE_TYPES.FACULTY
          ? {
              ...e,
              resourceIds: _.reject(
                [e.faculty1Id, e.faculty2Id, e.faculty3Id],
                _.isEmpty
              ),
            }
          : e;

      case EVENT_TYPES.ACTIVITY:
        return {
          ...e,
          resourceId:
            resourceType === RESOURCE_TYPES.FACULTY
              ? e?.FacultyBooking?.facultyId
              : e?.FacilityBooking?.facilityId,
        };

      //TODO: add session case
      case EVENT_TYPES.SESSION:
        return {
          ...e,
          resourceId:
            resourceType === RESOURCE_TYPES.FACULTY
              ? e?.FacultyBooking?.facultyId
              : e?.FacilityBooking?.facilityId,
        };

      default:
        return e;
    }
  });
};

const filterEventsByEventType = function (events = [], eventType) {
  if (eventType === EVENT_TYPES.ALL) {
    return events;
  }

  return events.filter((event) => event.eventType === eventType);
};

const filterEventsBySubjectCourseOffering = function (
  events = [],
  selectedSubjects = []
) {
  // filter events by subjects
  const isUnassignedSelected = selectedSubjects.includes(SUBJECT_UNASSIGNED);
  console.log('selectedSubjects: ', selectedSubjects);

  return events.filter((e) => {
    // if unassigned
    if (
      isUnassignedSelected &&
      !e?.SubjectPlanner?.courseOfferingId &&
      !e?.subjectId & !e?.courseOfferingId & !e?.courseId
    ) {
      return true;
    }

    return (
      _.intersection(selectedSubjects, [
        e?.subjectId,
        e?.SubjectPlanner?.courseOfferingId,
        e?.courseOfferingId,
        e?.courseId,
      ]).length > 0
    );
  });
};

export const filterEvents = function ({
  eventType = EVENT_TYPES_DEFAULT,
  selectedSubjects = [],
  allEvents = [],
  resourceType = RESOURCE_TYPES_DEFAULT,
}) {
  if (!selectedSubjects.length) {
    return [];
  }

  let events = filterEventsByEventType(allEvents, eventType);

  // add references to events
  // if (eventType === EVENT_TYPES.REFERENCE || eventType === EVENT_TYPES.ALL) {
  //     events = [...events, ...eventsResourceMapping(EVENT_TYPES.REFERENCE, referenceActivities, resourceType)]
  // }

  // //add sessions to events
  // if (eventType === EVENT_TYPES.ACTIVITY || eventType === EVENT_TYPES.ALL) {
  //     events = [...events, ...eventsResourceMapping(EVENT_TYPES.ACTIVITY, sessions, resourceType)]
  // }

  events = filterEventsBySubjectCourseOffering(events, selectedSubjects);

  events = eventsResourceMapping(events, resourceType);
  // event map and add resourceId by resourceType
  return events;
};

export const parseCourseVersionForTree = function (data) {
  return {
    id: '0',
    name: 'Select All',
    children: _.map(data, (course) => {
      return {
        ...course,
        name: course.courseName,
        children: _.map(course.courseOffering || [], (section) => ({
          ...section,
          name: section.courseSectionId,
        })),
      };
    }),
  };
};
